// FYI
// packages/@guardian/src-foundations/src/utils/focus-style-manager.ts SYMLINKS TO
// packages/@guardian/source-foundations/src/utils/focus-style-manager.ts
const TAB_KEY_CODE = 9;
/**
 * Source: Blueprint https://blueprintjs.com/
 * https://github.com/palantir/blueprint/blob/06a186c90758bbdca604ed6d7bf639c3d05b1fa0/packages/core/src/common/interactionMode.ts
 * A nifty little class that maintains event handlers to add a class to the container element
 * when entering "mouse mode" (on a `mousedown` event) and remove it when entering "keyboard mode"
 * (on a `tab` key `keydown` event).
 * Requires @babel/plugin-proposal-class-properties
 *
 * Modifications to original source:
 * - Add return types to `isActive`, `start` and `stop` functions
 */
export class InteractionModeEngine {
    // tslint:disable-next-line:no-constructor-vars
    constructor(container, className) {
        this.container = container;
        this.className = className;
        this.isRunning = false;
        this.handleKeyDown = (e) => {
            if (e.which === TAB_KEY_CODE) {
                this.reset();
                this.container.addEventListener('mousedown', this.handleMouseDown);
            }
        };
        this.handleMouseDown = () => {
            this.reset();
            this.container.classList.add(this.className);
            this.container.addEventListener('keydown', this.handleKeyDown);
        };
    }
    /** Returns whether the engine is currently running. */
    isActive() {
        return this.isRunning;
    }
    /** Enable behavior which applies the given className when in mouse mode. */
    start() {
        this.container.addEventListener('mousedown', this.handleMouseDown);
        this.isRunning = true;
    }
    /** Disable interaction mode behavior and remove className from container. */
    stop() {
        this.reset();
        this.isRunning = false;
    }
    reset() {
        this.container.classList.remove(this.className);
        this.container.removeEventListener('keydown', this.handleKeyDown);
        this.container.removeEventListener('mousedown', this.handleMouseDown);
    }
}
const FOCUS_DISABLED = 'src-focus-disabled';
let _focusEngine;
const focusEngine = () => {
    if (!_focusEngine)
        _focusEngine = new InteractionModeEngine(document.documentElement, FOCUS_DISABLED);
    return _focusEngine;
};
export const FocusStyleManager = {
    alwaysShowFocus: () => focusEngine().stop(),
    isActive: () => focusEngine().isActive(),
    onlyShowFocusOnTabs: () => focusEngine().start(),
};
//# sourceMappingURL=focus-style-manager.js.map
